import styled from 'styled-components'

import SVGCheckThick from '@Assets/SVG/CheckThick'
import { Link } from '@Components/Link'
import { up } from '@Globals/Style/breakpoints'
import { absoluteCenter } from '@Globals/Style/mixins'

export const LinkedProductsRoot = styled.section(({ theme }) => `
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: ${theme.padding.tablet} 5px;
  border-bottom: 5px solid ${theme.colors.greyLightest};

  & + & {
    padding-top: ${theme.padding.tablet};
  }

  ${up('mobileStyleThreshold')} {
    border-bottom: none;
    padding-top: 0;
    padding-bottom: 0;
  }
`)

export const LinkedProductTitle = styled.span`
  width: 100%;
  padding-top: 0;
  margin: 5px 5px 0;
  font-size: .75rem;
  text-transform: uppercase;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${up('mobileStyleThreshold')} {
    padding-top: 15px;

    ${LinkedProductsRoot} + ${LinkedProductsRoot} & {
      padding-top: 0;
    }
  }
`

export const LinkedProductContent = styled.div<{ isSelected?: boolean }>(({ isSelected }) => `
  width: 100%;
  padding-top: 100%;
  position: relative;
  border-radius: 50%;
  overflow: hidden;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,${isSelected ? '0.15' : '0.04'});
    z-index: 2;
  }
`)

export const LinkedProductRoot = styled(Link)(({ theme }) => `
  display: block;
  width: 20%;
  margin: ${theme.padding.mobile} 0;
  padding: 0 ${theme.padding.mobile};
  max-width: 90px;

  &:hover {
    ${LinkedProductContent} {
      outline: 1px solid #d9d9d9;
    }
  }

  ${up('phablet')} {
    width: 12.5%;
  }

  ${up('mobileStyleThreshold')} {
    width: 15%;
  }
`)

export const LinkedProductImageContainer = styled.div`
  ${absoluteCenter};
  width: calc(100% - 10px);
  height: calc(100% - 10px);
`

export const LinkedProductCheckmark = styled(SVGCheckThick)(({ theme }) => `
  ${absoluteCenter};
  z-index: 5;
  fill: #fff;
  width: 24px;
  height: 24px;
  stroke: ${theme.colors.grey};
  stroke-width: 20px;
`)
